
        var result = require("!!../../../../node_modules/css-loader/index.js!./tab.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/views/admin/tab.css
// module id = 1482
// module chunks = 0